//read a package
import React, { Component } from 'react';
import {BrowserRouter as Router,Route} from "react-router-dom"
import Navbar from "./components/CustomNavbar"

//read a componetns file
import Home from "./components/Home"
import About from "./components/About"
import News from "./components/News"


import './App.css';

class App extends Component {
  render() {
    return(
      <Router>
        <div>
          <Navbar/>
          {/* add a Route */}
          <Route exact path="/" component={Home}></Route>
          <Route path="/about" component={About}></Route>
          <Route path="/news"  component={News}></Route>
        </div>
      </Router>



    )
   
  }
}

export default App;
